"use client";

import { useEffect } from "react";

export default function DynamicTitle() {
  useEffect(() => {
    const fetchSiteData = async () => {
      try {
        const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL || "http://localhost:5000";
        const response = await fetch(`${backendUrl}/api/website/public/logos`);
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            // Atualiza o título
            if (data.data?.company_name) {
              document.title = data.data.company_name;
            }

            // Atualiza o favicon
            if (data.data?.favicon) {
              const existingFavicon = document.querySelector("link[rel='icon']");
              if (existingFavicon) {
                existingFavicon.setAttribute("href", data.data.favicon);
              } else {
                const link = document.createElement("link");
                link.rel = "icon";
                link.href = data.data.favicon;
                document.head.appendChild(link);
              }
            }
          }
        }
      } catch (error) {
        // Manter valores padrão
      }
    };
    fetchSiteData();
  }, []);

  return null;
}
